import { AggregateVectorParameterTypeInternal } from '../../../../api/openapi';
import type { ParametersData } from '../types/types';

export const parametersData: ParametersData = {
  FORWARD_ACTIVE_ENERGY: {
    unit: 'kWh',
    fixed: 3,
    color: {
      light: '#64b5f6',
      dark: '#1976d2',
    },
  },
  PREDICTION_FORWARD_ACTIVE_ENERGY: {
    unit: 'kWh',
    fixed: 3,
    color: {
      light: '#e79a4eff',
      dark: '#f57c00',
    },
  },
  PRICE: {
    unit: 'zł',
    fixed: 2,
    color: {
      light: '#4fc255ff',
      dark: '#388e3c',
    },
  },
  DYNAMIC_ENERGY_MARKET_PRICE: {
    unit: 'zł',
    fixed: 2,
    color: {
      light: '#4fc255ff',
      dark: '#388e3c',
    },
  },
  COST: {
    unit: 'zł',
    fixed: 2,
    color: {
      light: '#a04fc2ff',
      dark: '#702f8cff',
    },
  },
};

export const priceOrCostParameters = [
  AggregateVectorParameterTypeInternal.Price.toUpperCase(),
  AggregateVectorParameterTypeInternal.Cost.toUpperCase(),
  AggregateVectorParameterTypeInternal.VectorBalancedCost.toUpperCase(),
];
